export const DEFAULT_DATE_FORMAT = 'dd.LL.yyyy';
export const DEFAULT_DATE_TIME_FORMAT = 'dd.LL.yyyy HH:mm';
